// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { tripInspectionCostApi } from '../../lib/api';
import { type TripInspectionCost } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/trip-inspection-cost/';

export default (props: PageProps) => {
  const [data: TripInspectionCost, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await tripInspectionCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: TripInspectionCost) => {
    let id = payload.id;
    if (id) {
      await tripInspectionCostApi.update(payload);
    } else {
      let data = await tripInspectionCostApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: TripInspectionCost) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость предрейсовых/послерейсовых осмотров'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
